import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { YM_HIDE_CONTENT } from '@/shared/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'EmailOutput',
  props: {
    input: null,
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var output = computed(function () {
      if (props.input && typeof props.input === 'string') {
        var regex = /^[\S]+@[\w]+\.[\w.]+$/i;
        if (regex.test(props.input)) {
          return props.input;
        }
      }
      return null;
    });
    var link = computed(function () {
      return output.value ? "mailto:".concat(output.value) : null;
    });
    return {
      __sfc: true,
      props: props,
      output: output,
      link: link,
      YM_HIDE_CONTENT: YM_HIDE_CONTENT
    };
  }
});